import { Button, Container, Typography } from "@mui/material";
import { useContext, useState } from 'react';
import { MyAppBar } from "../components/Home/MyAppBar/myAppBar";
import AddIcon from '@mui/icons-material/Add';
import { MyProjectsList } from "../components/Project/myProjectsList";
import { AuthContext } from '../contexts/authContext';
import { NewProjectDialog } from "../components/Dialogs/newProjectDialog";
import { UserAppBar } from '../components/User/userAppBar';
import { db } from '../config/firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { useQuery } from '@tanstack/react-query';

export const MyProjects = () => {
    const { user } = useContext(AuthContext);
    const [newProjectDialogOpen, setNewProjectDialogOpen] = useState(false);

    const { data: uData, isDataLoading, isDataError } = useQuery({
        queryKey: ["loadprofile"], queryFn: async () => {
            const q = query(collection(db, "user"), where("owner", "==", user.uid));
            const data = await getDocs(q)

            const filteredData = data.docs.map((doc) => ({
                ...doc.data(),
            }));

            if (filteredData.length !== 1) {
                console.log("ERROR");
            }
            return filteredData[0];
        }
    });

    const handleCloseNewProjectDialog = () => {
        setNewProjectDialogOpen(false);
    }

    const handleNewProject = () => {
        setNewProjectDialogOpen(true);
    }

    return (
        <>
            <UserAppBar userData={uData} ></UserAppBar>
            <Container maxWidth="md" sx={{ pt: 5 }}>
                <div >
                    <div>
                        <Typography variant="h3">My Projects</Typography>
                    </div>
                    <p>
                        <Button variant="contained" startIcon={<AddIcon />} onClick={handleNewProject}>New Project</Button>
                    </p>
                    <MyProjectsList user={user}></MyProjectsList>
                    <NewProjectDialog open={newProjectDialogOpen} type={1} handleClose={handleCloseNewProjectDialog} uid={user.uid}></NewProjectDialog>
                </div>
            </Container>
        </>
    );
};